import { lazy, Suspense } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';

// Lazy load components that are below the fold or less critical
const Projects = lazy(() => import('./components/Projects').then(module => ({ default: module.Projects })));
const Cv = lazy(() => import('./components/Cv'));
const Certifications = lazy(() => import('./components/Certifications').then(module => ({ default: module.Certifications })));
const Skills = lazy(() => import('./components/Skills').then(module => ({ default: module.Skills })));
const SoftSkills = lazy(() => import('./components/SoftSkills').then(module => ({ default: module.SoftSkills })));
const Contact = lazy(() => import('./components/Contact').then(module => ({ default: module.Contact })));
const Footer = lazy(() => import('./components/Footer').then(module => ({ default: module.Footer })));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    color: '#fff'
  }}>
    <div>Loading...</div>
  </div>
);

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Suspense fallback={<LoadingFallback />}>
        <Projects />
        <Cv />
        <Certifications />
        <Skills />
        <SoftSkills />
        <Contact />
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
